import useText from "constants/text";
import _ from "lodash";
import React from "react";
import {useHistoryStyle } from "../style";
import {HistoryType } from "../types";
import { HistoryItem } from "./HistoryItem";


export const History : React.FC<HistoryType> = ({activities}) =>{
const {text} = useText();
const classes = useHistoryStyle();
    return(
        <div className={classes.container}>
         {activities?.map((activity, index)=>
            <div key={index}>
            <HistoryItem activity={activity} identifier={index} text={text} />
            </div>
         )}
       </div>
        
    )
};
